import { CellHeight } from './types'

export const tableBorderStyle = '1px solid rgba(30, 44, 71, 0.08)'

export const cellHeightValues: Record<CellHeight, number> = {
  condensed: 48,
  regular: 72,
}
